export type Maybe<T> = T | null;

export const isJust = <T>(x: Maybe<T>): x is T => {
  return x !== null;
};
